const MASKOTKA = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/g2ejgl6q_maskotka-obrys.webp";

const Cloud = ({ style, dur }) => (
  <div className="cloud-drift absolute" style={{ ...style, animationDuration: dur }}>
    <div className="relative">
      <div className="h-10 w-28 rounded-full border-[3px] border-[#0a0a0a] bg-[#f4f1ea]" />
      <div className="absolute -top-5 left-5 h-9 w-14 rounded-full border-[3px] border-[#0a0a0a] bg-[#f4f1ea]" />
      <div className="absolute -top-3 left-14 h-7 w-10 rounded-full border-[3px] border-[#0a0a0a] bg-[#f4f1ea]" />
    </div>
  </div>
);

export const WaveRow = ({ color, top, dur, reverse = false }) => (
  <div
    className="wave-row absolute left-0"
    style={{ top, height: 90, animationDuration: dur, animationDirection: reverse ? "reverse" : "normal" }}
  >
    {[0, 1].map((i) => (
      <svg key={i} viewBox="0 0 1200 90" preserveAspectRatio="none" style={{ width: "50%", height: "100%" }}>
        <path
          d="M0 45 Q75 8 150 45 T300 45 T450 45 T600 45 T750 45 T900 45 T1050 45 T1200 45 V90 H0 Z"
          fill={color}
          stroke="#0a0a0a"
          strokeWidth="3"
        />
      </svg>
    ))}
  </div>
);

const Gull = ({ style, dur, delay }) => (
  <svg className="gull-fly absolute" style={{ ...style, animationDuration: dur, animationDelay: delay }} width="52" height="20" viewBox="0 0 52 20">
    <path d="M2 14 Q13 2 26 14 Q39 2 50 14" fill="none" stroke="#0a0a0a" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

/* Cartoon figure: black tracksuit, balaclava, brown skin at the eyes */
const Figure = ({ x, y, standing = false, flip = false }) => {
  const h = standing ? 64 : 46;
  return (
    <g transform={`translate(${x} ${y}) ${flip ? "scale(-1 1)" : ""}`}>
      {/* torso — black dres */}
      <rect x="-13" y={standing ? 16 : 10} width="26" height={standing ? 34 : 26} rx="10" fill="#141416" stroke="#0a0a0a" strokeWidth="3.5" />
      {/* sleeve stripes */}
      <line x1="-11" y1={standing ? 22 : 15} x2="-11" y2={standing ? 44 : 30} stroke="#f4f1ea" strokeWidth="2.4" />
      <line x1="11" y1={standing ? 22 : 15} x2="11" y2={standing ? 44 : 30} stroke="#f4f1ea" strokeWidth="2.4" />
      {standing && <rect x="-10" y="48" width="20" height="16" rx="6" fill="#141416" stroke="#0a0a0a" strokeWidth="3.5" />}
      {/* head with balaclava */}
      <circle cx="0" cy="4" r="13" fill="#141416" stroke="#0a0a0a" strokeWidth="3.5" />
      {/* eye slit — skin + eyes */}
      <rect x="-9" y="-1" width="18" height="8" rx="4" fill="#6b4a2b" />
      <circle cx="-4" cy="3" r="1.6" fill="#f4f1ea" />
      <circle cx="4" cy="3" r="1.6" fill="#f4f1ea" />
      <title>{`crew ${h}`}</title>
    </g>
  );
};

/* Go-fast smuggler speedboat with 6 crew, bow facing right */
export const Speedboat = ({ dur = "24s", delay = "-3.2s", className = "" }) => (
  <div className={`raft-sail absolute bottom-[42%] left-0 z-10 sm:bottom-[31%] ${className}`} style={{ animationDuration: dur, animationDelay: delay }}>
    <div
      className="splash-pop absolute -left-[9%] bottom-[-14%] w-24 sm:w-32"
      data-testid="boat-splash"
      style={{ animationDuration: dur, animationDelay: delay }}
    >
      <svg viewBox="0 0 120 90" className="w-full">
        <g fill="#f4f1ea" stroke="#0a0a0a" strokeWidth="3">
          <circle cx="60" cy="52" r="16" />
          <circle cx="34" cy="62" r="10" />
          <circle cx="88" cy="60" r="9" />
          <path d="M52 40 L46 12 L58 34 L64 6 L68 34 L82 14 L74 40 Z" />
          <path d="M30 52 L12 40 L34 44 Z" />
          <path d="M92 50 L110 42 L94 58 Z" />
        </g>
      </svg>
    </div>
    <div className="raft-bob relative w-60 sm:w-[32rem]">
      <img
        src={MASKOTKA}
        alt="Mascot sternik"
        data-testid="speedboat-mascot"
        className="absolute left-[60.5%] top-[-3%] h-[46%] w-auto"
        style={{ filter: "drop-shadow(3px 3px 0 #0a0a0a)" }}
      />
      <svg viewBox="0 0 560 230" className="w-full">
        {/* wake spray */}
        <g fill="#f4f1ea" opacity="0.9">
          <circle cx="30" cy="196" r="9" />
          <circle cx="14" cy="206" r="6" />
          <circle cx="48" cy="208" r="5" />
          <path d="M70 200 q-30 6 -62 2 l0 10 q34 4 62 -2 Z" />
        </g>
        {/* twin outboards */}
        <g stroke="#0a0a0a" strokeWidth="4" fill="#0f0f12">
          <rect x="62" y="120" width="30" height="44" rx="8" />
          <rect x="96" y="120" width="30" height="44" rx="8" />
          <rect x="70" y="164" width="14" height="26" rx="5" />
          <rect x="104" y="164" width="14" height="26" rx="5" />
        </g>
        {/* hull */}
        <path
          d="M84 138 C 200 132 340 122 512 92 L 540 112 C 512 146 430 168 340 172 L 128 172 C 106 164 90 152 84 138 Z"
          fill="#1a1a1e"
          stroke="#0a0a0a"
          strokeWidth="5"
        />
        {/* terracotta stripe */}
        <path d="M110 146 C 240 138 380 126 500 106 L 506 114 C 388 136 246 148 112 154 Z" fill="#d96b43" stroke="#0a0a0a" strokeWidth="3" />
        {/* windshield + console */}
        <path d="M356 96 L 392 66 L 410 70 L 384 100 Z" fill="#7fd1d8" stroke="#0a0a0a" strokeWidth="4" opacity="0.95" />
        <rect x="330" y="96" width="70" height="30" rx="8" fill="#141416" stroke="#0a0a0a" strokeWidth="4" />
        {/* cargo bricks on bow deck */}
        <g stroke="#0a0a0a" strokeWidth="3.5">
          <rect x="448" y="96" width="54" height="18" rx="4" fill="#6b4a2b" />
          <rect x="458" y="80" width="44" height="16" rx="4" fill="#7a5533" />
          <line x1="448" y1="105" x2="502" y2="105" stroke="#d9c9a3" strokeWidth="4" />
          <line x1="458" y1="88" x2="502" y2="88" stroke="#d9c9a3" strokeWidth="4" />
        </g>
        {/* crew: 4 seated + bow lookout; Mascot pilnuje steru */}
        <Figure x={140} y={104} />
        <Figure x={185} y={100} />
        <Figure x={230} y={98} />
        <Figure x={275} y={96} />
        <Figure x={430} y={98} flip />
      </svg>
    </div>
  </div>
);

/* Small raft for the footer strip */
export const Raft = ({ dur = "70s", delay = "-32s", className = "" }) => (
  <div className={`raft-sail absolute bottom-[30%] left-0 z-10 ${className}`} style={{ animationDuration: dur, animationDelay: delay }}>
    <div className="raft-bob relative w-44">
      <svg viewBox="0 0 340 190" className="w-full">
        <g stroke="#0a0a0a" strokeWidth="4">
          <rect x="28" y="96" width="86" height="26" rx="5" fill="#6b4a2b" />
          <rect x="42" y="70" width="86" height="26" rx="5" fill="#7a5533" />
          <line x1="28" y1="109" x2="114" y2="109" stroke="#d9c9a3" strokeWidth="5" />
          <line x1="42" y1="83" x2="128" y2="83" stroke="#d9c9a3" strokeWidth="5" />
        </g>
        <g className="palm-sway">
          <rect x="236" y="92" width="44" height="34" rx="6" fill="#b9502f" stroke="#0a0a0a" strokeWidth="4" />
          <path d="M258 96 C 254 66 254 50 260 30" fill="none" stroke="#0a0a0a" strokeWidth="10" strokeLinecap="round" />
          <path d="M258 96 C 254 66 254 50 260 30" fill="none" stroke="#7a5533" strokeWidth="5" strokeLinecap="round" />
          <g fill="#2e6b3e" stroke="#0a0a0a" strokeWidth="3.5">
            <path d="M260 32 C 236 14 208 14 196 26 C 216 20 240 24 258 38 Z" />
            <path d="M260 32 C 284 12 312 12 324 24 C 304 18 280 22 262 38 Z" />
            <path d="M260 30 C 250 6 232 -2 218 2 C 234 4 250 14 258 34 Z" />
            <path d="M260 30 C 270 6 288 -2 302 2 C 286 4 270 14 262 34 Z" />
          </g>
        </g>
        <g stroke="#0a0a0a" strokeWidth="4">
          <rect x="8" y="126" width="324" height="18" rx="9" fill="#8a5a33" />
          <rect x="4" y="146" width="330" height="18" rx="9" fill="#7a4f2c" />
          <rect x="10" y="166" width="320" height="18" rx="9" fill="#8a5a33" />
        </g>
      </svg>
    </div>
  </div>
);

export const SeaScene = () => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden data-testid="sea-scene">
    <div
      className="absolute inset-0"
      style={{ background: "linear-gradient(180deg,#1d1226 0%,#4a2338 30%,#a8462c 52%,#d96b43 66%,#e5b83b 82%,#f2c14e 100%)" }}
    />
    <div className="absolute inset-0 halftone-light" />

    <div className="sun-pulse absolute left-1/2 top-[14%] h-40 w-40 rounded-full border-4 border-[#0a0a0a] bg-[#f2c14e] sm:h-60 sm:w-60" />

    <Cloud style={{ top: "9%" }} dur="75s" />
    <Cloud style={{ top: "20%", transform: "scale(0.7)" }} dur="95s" />
    <Cloud style={{ top: "4%", transform: "scale(1.25)" }} dur="60s" />

    <Gull style={{ top: "14%" }} dur="24s" delay="0s" />
    <Gull style={{ top: "22%" }} dur="31s" delay="-12s" />
    <Gull style={{ top: "8%" }} dur="20s" delay="-6s" />

    <div className="absolute bottom-0 left-0 right-0 h-[46%]">
      <div className="absolute inset-0 bg-[#0f3238]" />
      <WaveRow color="#2a7d82" top="-30px" dur="16s" />
      <WaveRow color="#1e5c60" top="12px" dur="11s" reverse />
      <WaveRow color="#16424a" top="60px" dur="8s" />
      <WaveRow color="#0f3238" top="112px" dur="6.5s" reverse />
    </div>

    <Speedboat />
  </div>
);
